<div class="binst-container d-flex flex-column">
<!--    <binsta-header-bar class="background-dark"></binsta-header-bar>-->
    <div class="background-dark w-100 d-flex column-holder">
        <div (mouseenter)="setChatHovered(true)"
             (mouseleave)="setChatHovered(false)"
             class="left-pane"
             [class.left-pane-active]="leftPaneActive && !chatsBarHovered"
             [class.left-pane-hovered]="chatsBarHovered && leftPaneActive"
        >
            <router-outlet name="left-pane"></router-outlet>
        </div>
        <div class="background-dark binst-window w-100 overflow-hidden"
             [ngClass]="{
                'binst-window-left-pane-active': leftPaneActive && !rightPaneActive,
                'binst-window-right-pane-active': rightPaneActive && !leftPaneActive,
                'binst-window-both-active': leftPaneActive && rightPaneActive
             }"
        >
            <canvas class="w-100" #canvas id="canvas" ></canvas>
            <div class="toolbar-holder-top d-flex justify-content-end mx-sm-5 mt-1 mx-2">
                    <toolbar-profile-search (profileClicked)="toggleProfile()"></toolbar-profile-search>
            </div>
            <div class="pop-up-top-right pane me-md-5 m-md-3 mt-2"
                [class.pane-top-right-active]="panePopUpTopRightActive"
            >
                <router-outlet name="pop-up-top-right"></router-outlet>
            </div>
            <div class="toolbar-holder-bottom ">
                <div class="d-flex new-modal-pane new-modal-pane-active pe-md-5 me-sm-5">
                    <router-outlet name="new-modal-pane"></router-outlet>
                </div>
                <div class="d-flex justify-content-between mx-sm-5 flex-md-row flex-column-reverse">
                    <div class="">
                        <toolbar-location></toolbar-location>
                    </div>
                    <div class="ms-auto">
                        <toolbar-actions></toolbar-actions>
                    </div>
                </div>
            </div>
        </div>
        <div class="background-dark right-pane " [class.right-pane-active]="rightPaneActive">
            <router-outlet name="right-pane"></router-outlet>
        </div>
        <context-menu></context-menu>
    </div>
</div>
<div class="debugger-values" *ngIf="showDebugWindow">
    <p>Debug values</p>
    @for (key of Object.keys(debuggers); track key) {
        <p>{{key}}: {{debuggers[key]}})</p>
    }
</div>
